import { useContainer } from '@hub-la/fe-container'
import { HttpClient } from '@hub-la/fe-core-http-client'
import { useQuery } from '@tanstack/react-query'
import { GetInvoicesInput } from '../../domain/dtos/get-invoices-input'
import { QueryKey } from '../../domain/enums/query-keys'
import { GetInvoices } from '../../usecases/get-invoices'

export const useGetInvoices = (input: GetInvoicesInput) => {
  const container = useContainer()

  const enabled = !!input.subscriptionId
  const initialData = {
    page: 1,
    pageSize: 0,
    total: 0,
    lastPage: 1,
    items: [],
  }

  return useQuery(
    [QueryKey.getInvoices, input.subscriptionId],
    () => {
      if (!enabled) {
        return Promise.resolve(initialData)
      }
      return new GetInvoices(container.get(HttpClient)).execute(input)
    },
    {
      retry: 3,
      retryOnMount: false,
      refetchOnWindowFocus: false,
      enabled,
      initialData,
    },
  )
}
